'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/4/19.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QueryNav = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(QueryNav, _Component);

  function QueryNav() {
    (0, _classCallCheck3.default)(this, QueryNav);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(QueryNav).call(this));
  }

  (0, _createClass3.default)(QueryNav, [{
    key: 'onNavClick',
    value: function onNavClick(index) {
      var _props = this.props;
      var onQueryNavItemClick = _props.onQueryNavItemClick;
      var outIndex = _props.outIndex;

      if (onQueryNavItemClick) {
        onQueryNavItemClick(index, outIndex);
      }
    }
  }, {
    key: 'onNavItemClick',
    value: function onNavItemClick(val) {
      var _props2 = this.props;
      var onNavItemClick = _props2.onNavItemClick;
      var outIndex = _props2.outIndex;

      if (onNavItemClick) {
        onNavItemClick(val, outIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./QueryNav.scss');
      var _props3 = this.props;
      var ativeItem = _props3.ativeItem;
      var navData = _props3.navData;
      var colorConvert = _props3.colorConvert;

      var navArray = [];
      var contentArray = [];
      if (colorConvert) {
        styles = require('./QueryNavConvert.scss');
      }
      navData.forEach(function (currentNavData, index) {
        var className = styles.shaixuan_zimu + ' font_a';
        if (index === ativeItem) {
          className = className + ' ' + styles.itemActive;
        }
        navArray.push(_react2.default.createElement(
          'div',
          { onClick: function onClick() {
              return _this2.onNavClick(index);
            }, key: index,
            className: className },
          currentNavData.title
        ));
        contentArray.push(_react2.default.createElement(
          'div',
          { key: index, className: styles.content,
            style: { display: index === ativeItem ? 'block' : 'none' } },
          _react2.default.createElement(
            'ul',
            null,
            currentNavData.content.map(function (info) {
              return _react2.default.createElement(
                'li',
                { key: info.value,
                  onClick: function onClick() {
                    return _this2.onNavItemClick(info.value);
                  },
                  className: styles.shaixuan_wenzi + ' ' + styles.shaixuan_wenzi0 },
                info.text
              );
            })
          )
        ));
      });
      return _react2.default.createElement(
        'div',
        { className: styles.all_shai },
        _react2.default.createElement(
          'div',
          { className: styles.nav },
          navArray
        ),
        contentArray
      );
    }
  }]);
  return QueryNav;
}(_react.Component), _class.propTypes = {
  navData: _react.PropTypes.array.isRequired,
  ativeItem: _react.PropTypes.number.isRequired,
  onQueryNavItemClick: _react.PropTypes.func,
  outIndex: _react.PropTypes.string.isRequired,
  onNavItemClick: _react.PropTypes.func,
  colorConvert: _react.PropTypes.bool
}, _temp);
exports.default = QueryNav;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/QueryNav/QueryNav.js
 ** module id = 1412
 ** module chunks = 0
 **/